import { call, post } from "@/services/api";
import type { MediaFile } from "@/services/media";
import type { ReturnEvent } from "@/services/stock";

export type CartState = "free" | "on_the_road" | "at_warehouse" | "lost";
export type Cart = {
  number: number; label: string; status: "free" | "linked"; state: CartState;
  myotaku_return_event_id: number | null; myotaku_contract_id: number | null; client_name: string | null;
  myotaku_warehouse_id: number | null; linked_by_hand: boolean;
  // The return as the planning showed it when the cart was linked, and "cart i of n for this client".
  return_title: string | null; return_type: string | null; return_starts_at: string | null;
  unit_index: number | null; unit_count: number | null; photo: MediaFile | null;
  linked_by: string | null; linked_at: string | null; arrived_by: string | null; arrived_at: string | null;
  freed_by: string | null; freed_at: string | null; updated_at: string | null;
  events?: { action: "link" | "arrive" | "stock" | "free"; return_event_id: number | null; client_name: string | null; by_name: string | null; at: string }[];
  return_carts?: Cart[]; ever?: number;
};

export const fetchCarts = (w?: number | null) =>
  call<{ count: number; carts: Cart[]; returns_without_cart: ReturnEvent[]; label_url: string; ever_by_return: Record<string, number> }>(
    `/api/v1/carts${w ? `?warehouse_id=${w}` : ""}`);
export const fetchCart = (n: number) => call<Cart>(`/api/v1/carts/${n}`);
export type CartAction = "link" | "arrive" | "free";
export const sendCartAction = (n: number, action: CartAction, body: Record<string, unknown>) =>
  post<Cart>(`/api/v1/carts/${n}/${action}`, body);
